import { Route } from "react-router-dom"
import MFCRedirectionPage from "./pages/MFCRedirectionPage"

export const MFCRedirectionRoutes = () => {
    return [
        // search params: redirectionType=qr or redirectionType=auto
        <Route key='mfc-redirection' path='/mfc-redirection' element={<MFCRedirectionPage />} />
    ]
}